
export function audioTracks() {
  return this.video && this.video.audioTracks;
}

export function autoplay() {
  return this.video && this.video.autoplay;
}

export function buffered() {
  return this.video && this.video.buffered;
}

export function controller() {
  return this.video && this.video.controller;
}

export function controls() {
  return this.video && this.video.controls;
}

export function crossOrigin() {
  return this.video && this.video.crossOrigin;
}

export function currentSrc() {
  return this.video && this.video.currentSrc;
}

export function currentTime() {
  return this.video && this.video.currentTime;
}

export function defaultMuted() {
  return this.video && this.video.defaultMuted;
}

export function defaultPlaybackRate() {
  return this.video && this.video.defaultPlaybackRate;
}

export function duration() {
  return this.video && this.video.duration;
}

export function ended() {
  return this.video && this.video.ended;
}

export function error() {
  return this.video && this.video.error;
}

export function loop() {
  return this.video && this.video.loop;
}

export function mediaGroup() {
  return this.video && this.video.mediaGroup;
}

export function muted() {
  return this.video && this.video.muted;
}

export function networkState() {
  return this.video && this.video.networkState;
}

export function paused() {
  return this.video && this.video.paused;
}

export function playbackRate() {
  return this.video && this.video.playbackRate;
}

export function played() {
  return this.video && this.video.played;
}

export function preload() {
  return this.video && this.video.preload;
}

export function readyState() {
  return this.video && this.video.readyState;
}

export function seekable() {
  return this.video && this.video.seekable;
}

export function seeking() {
  return this.video && this.video.seeking;
}

export function src() {
  return this.video && this.video.src;
}

export function startDate() {
  return this.video && this.video.startDate;
}

export function textTracks() {
  return this.video && this.video.textTracks;
}

export function videoTracks() {
  return this.video && this.video.videoTracks;
}

export function volume() {
  return this.video && this.video.volume;
}